import React, { useEffect, useState } from 'react';
import './Splash.css';

interface SplashProps {
  onFinish?: () => void;
}

const Splash: React.FC<SplashProps> = ({ onFinish }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        if (onFinish) onFinish();
      }, 300);
    }, 1000); // 2초 -> 1초로 단축

    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className={`splash-container ${fadeOut ? 'fade-out' : ''}`}>
      <img 
        src="/splash-image.png" 
        alt="삐삐 스플래시" 
        className="splash-image"
      />
    </div>
  );
};

export default Splash;